import {
  RefundEstimateBeforeConversionDetailsDto,
  RefundEstimateBeforeConversionDto,
  RefundEstimateBeforeConversionExchangeDto,
  RefundEstimateDetailsDto,
  RefundEstimateDto,
  RefundEstimateItemDto,
  RefundEstimateBeforeConversionDetailsModel,
  RefundEstimateBeforeConversionExchangeModel,
  RefundEstimateBeforeConversionModel,
  RefundEstimateDetailsModel,
  RefundEstimateItemModel,
  RefundEstimateModel,
} from '../types/refund-estimate'
import { transformCurrencyAmountDto } from './currency-amount'

export const transformRefundEstimateItemDto = (
  item: RefundEstimateItemDto,
): RefundEstimateItemModel => ({
  title: item.title,
  original: transformCurrencyAmountDto(item.original),
})

export const transformRefundEstimateItemsDto = (
  items: Array<RefundEstimateItemDto>,
): Array<RefundEstimateItemModel> => items.map(transformRefundEstimateItemDto)

export const transformRefundEstimateDetailsDto = (
  refundEstimateDetails: RefundEstimateDetailsDto,
): RefundEstimateDetailsModel => ({
  items: transformRefundEstimateItemsDto(refundEstimateDetails.items),
  itemsEstimatedRefundTotal: transformCurrencyAmountDto(
    refundEstimateDetails.items_estimated_refund_total,
  ),
  totalItemsDiscount: refundEstimateDetails.total_items_discount
    ? transformCurrencyAmountDto(refundEstimateDetails.total_items_discount)
    : null,
  buyerProtectionFee: transformCurrencyAmountDto(refundEstimateDetails.buyer_protection_fee),
  shipment: transformCurrencyAmountDto(refundEstimateDetails.shipment),
  returnShipment: refundEstimateDetails.return_shipment
    ? transformCurrencyAmountDto(refundEstimateDetails.return_shipment)
    : null,
  authenticityCheckFee: refundEstimateDetails.authenticity_check_fee
    ? transformCurrencyAmountDto(refundEstimateDetails.authenticity_check_fee)
    : null,
  electronicsVerificationFee: refundEstimateDetails.electronics_verification_fee
    ? transformCurrencyAmountDto(refundEstimateDetails.electronics_verification_fee)
    : null,
  salesTax: refundEstimateDetails.sales_tax
    ? transformCurrencyAmountDto(refundEstimateDetails.sales_tax)
    : null,
})

export const transformRefundEstimateBeforeConversionDetailsDto = (
  beforeConversionDetails: RefundEstimateBeforeConversionDetailsDto,
): RefundEstimateBeforeConversionDetailsModel => ({
  totalItemPrice: transformCurrencyAmountDto(beforeConversionDetails.total_item_price),
  shipment: transformCurrencyAmountDto(beforeConversionDetails.shipment),
  factualShippingMethod: beforeConversionDetails.factual_shipping_method,
})

export const transformRefundEstimateBeforeConversionExchangeDto = (
  beforeConversionExchange: RefundEstimateBeforeConversionExchangeDto,
): RefundEstimateBeforeConversionExchangeModel => ({
  baseRate: transformCurrencyAmountDto(beforeConversionExchange.base_rate),
  exchangeRate: transformCurrencyAmountDto(beforeConversionExchange.exchange_rate),
})

export const transformRefundEstimateBeforeConversionDto = (
  refundEstimateBeforeConversion: RefundEstimateBeforeConversionDto,
): RefundEstimateBeforeConversionModel => ({
  details: transformRefundEstimateBeforeConversionDetailsDto(
    refundEstimateBeforeConversion.details,
  ),
  exchange: transformRefundEstimateBeforeConversionExchangeDto(
    refundEstimateBeforeConversion.exchange,
  ),
  markup: refundEstimateBeforeConversion.markup,
})

export const transformRefundEstimateDto = (
  refundEstimate: RefundEstimateDto,
): RefundEstimateModel => ({
  estimatedRefundWithoutShipment: refundEstimate.estimated_refund_without_shipment
    ? transformCurrencyAmountDto(refundEstimate.estimated_refund_without_shipment)
    : null,
  totalEstimatedRefund: transformCurrencyAmountDto(refundEstimate.total_estimated_refund),
  details: transformRefundEstimateDetailsDto(refundEstimate.details),
  beforeConversion: refundEstimate?.before_conversion
    ? transformRefundEstimateBeforeConversionDto(refundEstimate.before_conversion)
    : null,
})
